// aswin p c
import { PROJECT_DETAILS_REPORT ,DEPOSITION_REPORT ,CHANELPARTNER_REPORT} from "../types";

const initialState = {
  // response: { data: { roles: [] }, message: "" },
  depositionReport: null,
  getAllChanelPartnerData:[],
  projectDetails: { bookings: {}, siteVisits: {}, bookings1: [], siteVisits1: [], message: "" },
  loading: true,
  create: false,
  detail: false,
};

const webReportReducer = (state = initialState, action) => {
  switch (action.type) {
    // case ROLEWISE_PROJECT_REPORT:
    //   return {
    //     ...state,
    //     create: false,
    //     detail: false,
    //     loading: false,
    //     response: action.payload, // Set the payload directly
    //      // Set loading to false when the action is dispatched
    //   };

      case PROJECT_DETAILS_REPORT:
        return {
          ...state,
          create: false,
          detail: false,
          loading: false,
          projectDetails: action.payload, // Update the state with project details report data
         // Set loading to false
        };

        case DEPOSITION_REPORT:
        return {
          ...state,
          create: false,
          detail: false,
          loading: false,
          depositionReport: action.payload, // Update the state with project details report data
         // Set loading to false
        };

        case CHANELPARTNER_REPORT:
          return {
            ...state,
            create: false,
            detail: false,
            loading: false,
            getAllChanelPartnerData: action.payload,
          }
        
    default:
      return state;
  }
};

export default webReportReducer;
